import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { legalFor, PRIVACY_PUBLISHED, TERMS_PUBLISHED } from "@/i18n/legal";
import { supportFor } from "@/i18n/support";

// Liens « Politique de confidentialité » / « Conditions d'utilisation » / « Contact / Assistance » (pied de page, pages publiques, paramètres).
export function LegalLinks({ className = "", testIdPrefix = "legal" }) {
  const { lang } = useLang();
  const { labels } = legalFor(lang);
  const support = supportFor(lang);
  return (
    <nav className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground ${className}`} aria-label="Legal">
      {PRIVACY_PUBLISHED && <Link to="/privacy" className="hover:text-foreground underline-offset-4 hover:underline" data-testid={`${testIdPrefix}-privacy-link`}>{labels.privacy}</Link>}
      {TERMS_PUBLISHED && <Link to="/terms" className="hover:text-foreground underline-offset-4 hover:underline" data-testid={`${testIdPrefix}-terms-link`}>{labels.terms}</Link>}
      <Link to="/support" className="hover:text-foreground underline-offset-4 hover:underline" data-testid={`${testIdPrefix}-support-link`}>{support.title}</Link>
    </nav>
  );
}
